import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface GetIdentityProviderUserInfoOverridesResponse extends BackendResponse {
  item: IdentityProviderUserInfoOverrides;
}

export interface GetIdentityProviderUserInfoOverridesParameters extends NextApiParams {}

export const getIdentityProviderUserInfoOverrides = withNextApi<
  GetIdentityProviderUserInfoOverridesResponse,
  GetIdentityProviderUserInfoOverridesParameters
>("/auth/GetIdentityProviderUserInfoOverrides", { method: "GET" });

export interface IdentityProviderUserInfoOverrides {
  firstname: string | null;
  lastname: string | null;
  email: string | null;
  phoneNumber: string | null;
  emailVerified: string | null;
  phoneVerified: string | null;
  userId: string | null;
}
